import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from './store';
import navItemsConfig from '../static/navItems';
import type { BFMenuItem } from '../components/BFMenu/BFMenu';
import { UserRole } from '../constants/enums';

/**
 * Returns the filtered and mapped `BFMenuItem[]` based on the current user's role.
 * Items with an empty `allowedRoles` array are visible to everyone.
 */
export default function useNavItems(): BFMenuItem[] {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const loggedUser = useAppSelector((state) => state.global.loggedUser);
    const roles = loggedUser?.roles as UserRole[] | undefined;

    return navItemsConfig
        .filter((item) => {
            // visible to all
            if (item.allowedRoles.length === 0) return true;
            // not logged in
            if (!loggedUser) return false;
            // logged in but roles unknown — show everything
            if (!roles || roles.length === 0) return true;
            return item.allowedRoles.some((r) => roles.includes(r));
        })
        .map((item) => ({
            id: item.id,
            label: t(item.labelKey),
            active: location.pathname === item.link,
            onClick: () => navigate(item.link),
        }));
}
